import React from "react";
import Fade from "react-reveal/Fade";
import { Link } from "gatsby";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheckCircle,
  faExclamationCircle,
  faClipboardList,
} from "@fortawesome/free-solid-svg-icons";

const Message = (props) => {

    let message_box_class = "";
    let message_tip_icon_class = "";
    let message_box_icon = "";

    switch (props.infoType) {
        case "error":
          // MFA SET_UP REQUIRED
          message_tip_icon_class = "tip-icon-danger";
          message_box_class = "new-message-box-danger";
          message_box_icon = faExclamationCircle;
          break;
        case "success":
          // INVALID PASSCODE -- DISPLAY ERROR
          message_tip_icon_class = "tip-icon-success";
          message_box_class = "new-message-box-danger";
          message_box_icon = faCheckCircle;
          
          //setLoginStage(2);
          break;
        default:
            message_tip_icon_class = "tip-icon-success";
            message_box_class = "new-message-box-danger";
            message_box_icon = faCheckCircle;
        // code block
        // UNKNOWN ERROR - CREATE ERROR
      }


  return (
    <Fade>
      <div className="new-message-box">
        <div className={message_box_class}>
          <div className={'info-tab '+ message_tip_icon_class} title="error">
            <div className="tip-icon">
              <i>
                <FontAwesomeIcon icon={message_box_icon} />
              </i>
            </div>
          </div>
          <div className="tip-box-danger">
            <h1>{props.infoTitle}</h1>
            <p>{props.infoDesc}</p>
            <div className="mb-3">{props.infoLink?(
              <Link className="mb-2" to={props.infoLink}> <i className="mr-2">
              <FontAwesomeIcon icon={faClipboardList} />
            </i>View Logs</Link>
             
              
            ):null}
            </div>
          </div>
        </div>
      </div>
    </Fade>
  );
};

export default Message;
